import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "golf-page" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = {
  key: 0,
  class: "pagination-container"
}
const _hoisted_4 = { class: "pagination-info" }

import { ref, onMounted, computed, watch } from 'vue'
import { ElMessage } from 'element-plus'
import CommonError from '@/components/CommonError.vue'
import { useRouter } from 'vue-router'
import { useGolfUsersStore } from '@/store/golf-users'
import { routeNames } from '@/router/route-names'
import type { GolfUser } from '@/api/golf'
import { useGolfHeaderStore } from '@/store/golf-header'
import { useGolfI18n } from '@/composables/useGolfI18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const router = useRouter()
const golfStore = useGolfUsersStore()
const headerStore = useGolfHeaderStore()
const { t } = useGolfI18n()

const searchQuery = computed({
  get: () => headerStore.searchQuery,
  set: (val) => headerStore.setSearchQuery(val)
})
const statusFilter = ref<string | undefined>(undefined)
const currentPage = ref(1)

watch(() => headerStore.searchQuery, () => {
  applyFilters()
})

const applyFilters = () => {
  currentPage.value = 1
  golfStore.fetchUsers({
    status_golf: statusFilter.value,
    q: searchQuery.value || undefined,
    page: currentPage.value,
  })
}

const onRetryPress = () => {
  golfStore.fetchUsers({
    status_golf: statusFilter.value,
    q: searchQuery.value || undefined,
    page: currentPage.value,
  })
}

const handlePageChange = (page: number) => {
  currentPage.value = page
  golfStore.fetchUsers({
    status_golf: statusFilter.value,
    q: searchQuery.value || undefined,
    page: currentPage.value,
  })
}

const viewUser = (user: GolfUser) => {
  router.push({ name: routeNames.golfUserDetails, params: { id: user.id } })
}

const toggleGolfAccess = async (user: GolfUser) => {
  const newStatus = user.status_golf === 'active' ? 'inactive' : 'active'
  await golfStore.updateUserStatus(user.id, newStatus)
}

const getStatusClass = (status: string) => {
  return status === 'active' ? 'status-active' : 'status-inactive'
}

const formatName = (user: GolfUser) => {
  if (user.name) return user.name
  const parts: string[] = []
  if (user.first_name) parts.push(user.first_name)
  if (user.last_name) parts.push(user.last_name)
  return parts.join(' ') || '-'
}

const formatAge = (user: GolfUser) => {
  if (user.age !== undefined && user.age !== null) {
    return `${user.age} years`
  }
  if (user.date_of_birth) {
    const birth = new Date(user.date_of_birth)
    const today = new Date()
    let age = today.getFullYear() - birth.getFullYear()
    const m = today.getMonth() - birth.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--
    }
    return `${age} years`
  }
  return '-'
}

const formatDrivingExperience = (user: GolfUser) => {
  let months = user.driving_experience_months

  if ((months === undefined || months === null) && user.driver_license_issue_date) {
    const issue = new Date(user.driver_license_issue_date)
    const now = new Date()
    months =
      (now.getFullYear() - issue.getFullYear()) * 12 +
      (now.getMonth() - issue.getMonth())
  }

  if (months === undefined || months === null) return '-'
  const years = Math.floor(months / 12)
  const remainingMonths = months % 12
  if (years > 0 && remainingMonths > 0) {
    return `${years} years ${remainingMonths} months`
  }
  if (years > 0) {
    return `${years} years`
  }
  return `${remainingMonths} months`
}

const exportUsers = () => {
  ElMessage.success(t('golf.financial.exporting_report') || 'Exported successfully')
}

onMounted(() => {
  headerStore.setHeaderInfo('golf.users.title', true, 'golf.header.search_placeholder')
  golfStore.fetchUsers({ page: currentPage.value })
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(golfStore).error)
      ? (_openBlock(), _createBlock(CommonError, {
          key: 0,
          errorMessage: _unref(golfStore).error,
          onRetryPress: onRetryPress
        }, null, 8, ["errorMessage"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_select, {
          modelValue: statusFilter.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statusFilter).value = $event)),
          placeholder: _ctx.$t('golf.users.filter_golf_status'),
          clearable: "",
          style: {"width":"200px"},
          onChange: applyFilters
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.fleet.all'),
              value: undefined
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.common.active'),
              value: "active"
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.fleet.status_inactive'),
              value: "inactive"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: exportUsers,
          style: {"margin-left":"auto"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.promo.export') || 'Export'), 1)
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(golfStore).users,
        style: {"width":"100%"},
        class: "users-table"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: "ID",
            "min-width": "100"
          }),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.common.user'),
            "min-width": "150"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(formatName(row)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "email",
            label: _ctx.$t('golf.common.email'),
            "min-width": "200"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.common.age'),
            "min-width": "80"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(formatAge(row)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.common.driving_experience'),
            "min-width": "120"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(formatDrivingExperience(row)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.common.status'),
            "min-width": "120"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", {
                class: _normalizeClass(getStatusClass(row.status_golf))
              }, _toDisplayString(row.status_golf === 'active'
                ? _ctx.$t('golf.common.active')
                : _ctx.$t('golf.fleet.status_inactive')), 3)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.menu.trips'),
            "min-width": "80"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.trips_count), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.trips.actions'),
            "min-width": "170"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                plain: "",
                type: "primary",
                size: "small",
                onClick: ($event: any) => (viewUser(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('golf.fleet.view')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: row.status_golf === 'active' ? 'danger' : 'success',
                size: "small",
                onClick: ($event: any) => (toggleGolfAccess(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.status_golf === 'active'
                ? _ctx.$t('golf.common.revoke')
                : _ctx.$t('golf.common.grant')), 1)
                ]),
                _: 2
              }, 1032, ["type", "onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(golfStore).isLoading]
      ]),
      (_unref(golfStore).usersMeta && _unref(golfStore).usersMeta.total > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('golf.trips.showing_results', {
            start: (currentPage.value - 1) * _unref(golfStore).usersMeta.perPage + 1,
            end: Math.min(
              currentPage.value * _unref(golfStore).usersMeta.perPage,
              _unref(golfStore).usersMeta.total
            ),
            total: _unref(golfStore).usersMeta.total,
          })), 1),
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, pager, next",
              total: _unref(golfStore).usersMeta.total,
              disabled: _unref(golfStore).isLoading,
              "page-size": _unref(golfStore).usersMeta.perPage,
              currentPage: currentPage.value,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
              onCurrentChange: handlePageChange
            }, null, 8, ["total", "disabled", "page-size", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})